import { HeartOutlined } from "@ant-design/icons";
import { ReportMedia } from "@shared/lib/types/reports";
import { Alert, Col, Flex, Row, Typography } from "antd";

const { Title } = Typography;

export function TopMediaComments({ media }: { media: ReportMedia }) {
  if (!media.commentData) {
    return null;
  }
  return (
    <div>
      <Title level={3}> Top Relevant Comments</Title>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Flex vertical gap={15}>
            <Alert
              message="Positive comments"
              type="success"
              showIcon
              icon={<HeartOutlined />}
            />
            {media?.commentData?.positiveComment?.slice(0, 6).map((comment) => (
              <div
                style={{
                  borderRadius: "24px 24px 24px 0",
                  border: "1.5px solid #e5e5e8",
                  background: "#fff",
                  padding: "16px",
                }}
              >
                {comment}
              </div>
            ))}
          </Flex>
        </Col>
        <Col span={12}>
          <Flex vertical gap={15}>
            <Alert message="Negative comments" type="warning" showIcon />
            {media?.commentData?.negativeComment?.slice(0, 6).map((comment) => (
              <div
                style={{
                  borderRadius: "24px 24px 0 24px",
                  border: "1.5px solid #e5e5e8",
                  background: "#fff",
                  padding: "16px",
                }}
              >
                {comment}
              </div>
            ))}
          </Flex>
        </Col>
      </Row>
    </div>
  );
}
